import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ } from "./data";
import { Reveal, Eyebrow } from "./Reveal";

export const Faq = () => (
  <section id="intrebari" data-testid="faq-section" className="bg-white py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Întrebări frecvente</Eyebrow>
        <h2 className="mt-5 font-display text-4xl sm:text-5xl font-semibold leading-[1.02] tracking-[-0.02em]">
          Pe <span className="italic font-black text-[#5FB4E2]">scurt</span>.
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQ.map((f, i) => (
            <AccordionItem key={i} value={`q${i}`} className="border-[#0B1120]/15">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl sm:text-2xl font-medium hover:no-underline hover:text-[#1F6F99]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[#475569] leading-relaxed pb-6 max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
